// Proje tasarımı (Projects.projectDesign): çalışmanın körleme yapısı.

export const PROJECT_DESIGN = {
  DOUBLE_BLIND: 'double-blind',
  OPEN_LABEL: 'open-label',
  HYBRID: 'hybrid',
};

// react-select ile uyumlu { value, label } listesi
export const PROJECT_DESIGN_OPTIONS = [
  { value: PROJECT_DESIGN.DOUBLE_BLIND, label: 'Çift Kör' },
  { value: PROJECT_DESIGN.OPEN_LABEL, label: 'Open Label (Açık Etiketli)' },
  { value: PROJECT_DESIGN.HYBRID, label: 'Hibrit' },
];

export const getProjectDesignLabel = (value) =>
  PROJECT_DESIGN_OPTIONS.find((option) => option.value === value)?.label || '';

export const isHybridProject = (project) => project?.projectDesign === PROJECT_DESIGN.HYBRID;

// Open label çalışmada körleme yoktur: çalışandan kör çalışma durumu beklenmez
export const isOpenLabelProject = (project) => project?.projectDesign === PROJECT_DESIGN.OPEN_LABEL;
